import { render, staticRenderFns } from "./ReportsAdvisor.vue?vue&type=template&id=b1c0a968"
import script from "./ReportsAdvisor.vue?vue&type=script&lang=js"
export * from "./ReportsAdvisor.vue?vue&type=script&lang=js"
import style0 from "./ReportsAdvisor.vue?vue&type=style&index=0&id=b1c0a968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports